var exports = {
  "VH": "GameActivityTab.module__preview___MzA5RT",
  "HL": "GameActivityTab.module__widget___MzA5RT",
  "Gg": "GameActivityTab.module__dashed___MzA5RT",
  "kQ": "GameActivityTab.module__user___MzA5RT",
  "my": "GameActivityTab.module__avatar___MzA5RT",
  "su": "GameActivityTab.module__avatarSpeaking___MzA5RT",
  "dT": "GameActivityTab.module__avatarSmall___MzA5RT",
  "nU": "GameActivityTab.module__avatarMedium___MzA5RT",
  "Jb": "GameActivityTab.module__avatarLarge___MzA5RT",
  "UU": "GameActivityTab.module__name___MzA5RT",
  "fh": "GameActivityTab.module__nameText___MzA5RT",
  "I8": "GameActivityTab.module__statusIcon___MzA5RT",
  "WG": "GameActivityTab.module__channelRow___MzA5RT",
  "Ix": "GameActivityTab.module__channel___MzA5RT",
  "VN": "GameActivityTab.module__close___MzA5RT",
  "ZY": "GameActivityTab.module__sliderBlock___MzA5RT",
  "KF": "GameActivityTab.module__sliderLabel___MzA5RT",
};

module.exports = exports;
